import { CURRENT_MAP_VERSION, OLDEST_SUPPORTED_MAP_VERSION } from './version.ts';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/**
 * Why `migrateMapDocument` would return null. Null means the value would load.
 * Keep this aligned with the gates in migrate — do not change migrate's `X | null` contract.
 */
export function diagnoseMapDocument(value: unknown): string | null {
  if (!isRecord(value)) {
    return 'That file is not a Battleboats map.';
  }

  const version = value.version;

  if (typeof version !== 'number' || !Number.isFinite(version)) {
    return 'That file has no map version.';
  }

  if (version < OLDEST_SUPPORTED_MAP_VERSION) {
    return `That map is too old (version ${version}). This build reads versions ${OLDEST_SUPPORTED_MAP_VERSION}–${CURRENT_MAP_VERSION}.`;
  }

  if (version > CURRENT_MAP_VERSION) {
    return `That map is too new (version ${version}). This build reads up to version ${CURRENT_MAP_VERSION}.`;
  }

  const missingBounds = !isRecord(value.bounds);
  const missingIslands = !Array.isArray(value.islands);

  if (missingBounds && missingIslands) {
    return 'That file is missing map bounds and an islands list.';
  }

  if (missingBounds) {
    return 'That file is missing map bounds.';
  }

  if (missingIslands) {
    return 'That file is missing an islands list.';
  }

  return null;
}
